export default "__VITE_ASSET__75c72903__"